import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { apiClientV2 } from '~/api/client';

interface Payload {
  id: string;
}

export const useRemoveSavedList = () => {
  return useMutation<AxiosResponse, AxiosError, Payload, AxiosResponse>(
    (payload) => {
      return apiClientV2.delete(`saved-lists/${payload.id}`);
    },
  );
};
